import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/constant';

export interface CascaderOption {
  id?: number;
  code?: string;
  name: string;
  children?: CascaderOption[];
}

export interface StationInfo {
  stationName: string;
  stationNumber: string;
}

export interface VehicleModelInfo {
  vehicleModelType: string;
  vehicleModelName: string;
}

export enum downLoadUrlType {
  CARD = 2,
  VEHICLE = 1,
}
class CommonApi {
  getStationDepartment(params: {
    stationProductType?: 'vehicle' | 'robot' | 'integrate';
    cityIdList?: any[];
    stationUseCaseList?: any[];
    stationType?: string;
    enable?: any;
    companyNumber?: string;
  }) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/common/get_cascade_station_address_list',
      body: params,
    };
    return request(options);
  }

  getCityDepartment() {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/common/get_state_city_address_list',
    };
    return request(options);
  }

  getCommonDropDown({ keyList }: { keyList: Array<string> }) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/common/common_get_down_list',
      body: { keyList },
    };
    return request(options);
  }

  fetchERP() {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/common/common_get_erp_list',
    };
    return request(options);
  }

  getDownloadURL(type: downLoadUrlType) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/upload/get_download_url',
      body: {
        type,
      },
    };
    return request(options);
  }

  async upload(requestType, params: { bucketName: string; fileKey: string }) {
    let uploadUrl = '';
    if (requestType === 'VEHICLE_BATCH_ADD') {
      uploadUrl = '/k2/management/upload/device_batch_add';
    } else if (requestType === 'VEHICLE_CARD_NO_BATCH_ADD') {
      uploadUrl = '/k2/management/upload/device_card_no_batch_add';
    }
    const options: RequestOptions = {
      method: 'POST',
      path: uploadUrl,
      body: params,
    };
    return request(options);
  }

  getUploadPreUrl(params: { bucketName: string; fileKey: string }) {
    const options: RequestOptions = {
      method: 'POST',
      path: '/infrastructure/oss/getPreUrl',
      body: params,
    };
    return request(options);
  }

  // 获取省市区cascader下拉框
  async getProvinceCityCountyList(): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/common/get_province_city_country_list',
      method: Method.POST,
    };
    return request(requestOptions);
  }

  // 获取省区分区下拉框
  async getProvinceAgencyAreaList(): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/common/get_province_agency_area_list',
      method: Method.POST,
    };
    return request(requestOptions);
  }

  // 获取站点列表下拉框
  async getStationList(): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/deployment/common/getStationList',
      method: Method.POST,
    };
    return request(requestOptions);
  }

  // 根据省市查询站点列表
  async getStationListByAddress(params: {
    provinceId?: number | null;
    cityId?: number | null;
    countyId?: number | null;
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/common/getStationList',
      method: Method.POST,
      body: params,
    };
    return request(requestOptions);
  }

  // 获取下单车型列表下拉框
  async getVehicleModelList(): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/deployment/requirement/getVehicleModelList',
      method: Method.POST,
    };
    return request(requestOptions);
  }

  // 根据用户erp获取详细信息
  async getStationInfoByErp(erp: string): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/common/getStationInfoByErp',
      method: Method.POST,
      body: { erp },
    };
    return request(requestOptions);
  }

  // 通过站点number查询站点信息
  async getQlStationInfoByNumber(stationNumber: string): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/common/getQlStationInfoByNumber',
      method: Method.POST,
      body: { stationNumber },
    };
    return request(requestOptions);
  }

  // 根据车号获取车架&车型
  async getVehicleDetailByName(vehicleName: string): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/device/get_detail_by_name',
      method: Method.POST,
      body: { vehicleName },
    };
    return request(requestOptions);
  }
}

const commonApi = new CommonApi();
export { CommonApi, commonApi };
